module.exports = __webpack_public_path__ + "static/media/loginImage.d98186cf.png";